import React from "react";
import { Icon } from "./Icon";
export const IconSearch = (props) => (
    <Icon {...props}>
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </Icon>
);